import isMatch from 'lodash/isMatch';

import { type AnalyticsEventPayload, type UIAnalyticsEvent } from '@atlaskit/analytics-next';

import type { Callback, Matcher, PostOfficeGasv3ListenerStore } from './types';

const createPostOfficeGasv3ListenerStore = (): PostOfficeGasv3ListenerStore => {
	const subscribers = new Map<Matcher, Callback>();

	const handleEvent = (event: UIAnalyticsEvent) => {
		subscribers.forEach((callback, matcher) => {
			if (isMatch(event.payload, matcher)) {
				callback();
			}
		});
	};

	const subscribe = (matcher: AnalyticsEventPayload, callback: Callback) => {
		subscribers.set(matcher, callback);

		return () => {
			subscribers.delete(matcher);
		};
	};

	return {
		subscribe,
		handleEvent,
	};
};
const postOfficeGasv3ListenerStore = createPostOfficeGasv3ListenerStore();

export { postOfficeGasv3ListenerStore };
